import React, { useEffect, useState, memo, useRef } from "react";

import navLinks from "../../constans/navlink";
import { slide as Menu } from "react-burger-menu";
import IMAGES from "../../constans/images";
import { useNavigate,Link, useLocation } from "react-router-dom";
import { openMenu } from "../../../pages/Home/redux/actions";
import { useDispatch, useSelector } from "react-redux";

import * as actionLogout from '../../../pages/Account/redux/actions';
import ROUTERS from "../../constans/router";
import {checkImgUrl, formatAppSnsType, removeAllStorage} from "../../../utils/helpers";
import {logOutRequest} from "../../../pages/Account/redux/actions";
import DialogComponent from "../../../commons/components/Modal/DialogComponent";
import API, {ROUTES} from "../../api/api";
import useOnClickOutside from "../../customHooks/useClickOutSide";
import { isAndroid } from "react-device-detect";
type Props = {
};
const Menubar = ({}: props) => {
  const { menuStatus } = useSelector((state) => state.homeReducers);
  const { userInfo } = useSelector((state) => state.authReducers);
  const location = useLocation();
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const dispatch = useDispatch();
  const ref = useRef();

  useOnClickOutside(ref, () => {
    dispatch(openMenu(false))
  }, []);

  const [dialogDeleteUser,setDialogDeleteUser] = useState(false);

  const [dialogLogoutUser, setDialogLogoutUser] = useState(false);

  const DEFAULT_IMAGE = '/images/img_profile.png';

  const handleClickNav = (nav) => {
    if (nav.toUrl && nav.toUrl != "") {
      navigate(nav.toUrl);
    } else if (nav.action && nav.action != "") {
      // code for u
    }
  };

  // const renderNavlinks = () =>
  //   navLinks && navLinks.map((nav) => {
  //     return (<li key={nav.id} className='menu-bar__content__item'>
  //               <a className='menu-bar__content__item__text' onClick={() => handleClickNav(nav)}>{nav.name}</a>
  //             </li>)
  //   });


  useEffect(() => {
    setIsMenuOpen(menuStatus);
    if (menuStatus) {
      window.document.body.style.overflow = 'hidden'
      window.addEventListener('click', function (e) {
        if (document.getElementById('js-menu-right').contains(e.target)) {
          // console.log(e.target, 'js-menu-right 1111');
        }else{
          // console.log(e.target, 'js-menu-right 2222');
          dispatch(openMenu(false));
        }
      })
    }else{
      window.document.body.style.overflow = 'auto'
    }
  }, [menuStatus]);

  useEffect(() => {
    setIsMenuOpen(isMenuOpen);
  }, [isMenuOpen]);

  useEffect(() => {
    if (location.state?.menuStatus && location.state?.menuStatus === true) {
      dispatch(openMenu(true));
      navigate(location.pathname, { replace: true });
    } else {
      dispatch(openMenu(false));
    }
  }, [location.state]);

  const handleCloseMenu = () => {
    dispatch(openMenu(false));
    if (isAndroid) {
      window.nativeRightMenu(false);
    }
  };

  const handleStateChange = (state) => {
    dispatch(openMenu(state.isOpen));
    setIsMenuOpen(state.isOpen);
    if (isAndroid) {
      window.nativeRightMenu(state.isOpen);
    }
  };

  const handleLogout = () => {
    setIsMenuOpen(true)
    setDialogLogoutUser(true);
  }

  const onClickLogout = () => {
    // reset state
    dispatch(logOutRequest());
    setDialogLogoutUser(false);
    dispatch(openMenu(false));
    dispatch(actionLogout.resetState());
    window.logoutSNS(userInfo?.devices[0]?.login_type || 'N/A');
  }

  const goToPage = (url) => {
    setIsMenuOpen(false);
    dispatch(openMenu(false));
    navigate(url)
  }

  const deleteAccount = () => {
    setDialogDeleteUser(true)
  }

  const onClickDeleteAccount = () => {
    API.post(ROUTES.API_DELETE_USER).then(res => {
      //remove all local storage
      let snsType = formatAppSnsType(localStorage.getItem('sns_type') || '');
      window.nativeLogoutToken(snsType);
      removeAllStorage();
      dispatch(openMenu(false));
      setDialogDeleteUser(false)
      dispatch(actionLogout.resetState());
      window.logoutSNS(userInfo?.devices[0]?.login_type || 'N/A');

    })
  }

  let avatar_path = DEFAULT_IMAGE;
  if(userInfo.avatar){
    avatar_path = userInfo.avatar_url.thumbnail;
    if(checkImgUrl(userInfo.avatar)){
      avatar_path = userInfo.avatar
    }
  }

  const shouldDisableOverlayClick = () => {
  }

  const handleOnClose = () => {
  }

  return (
    <Menu
      right
      className={"menu-wrap-right"}
      isOpen={isMenuOpen}
      onStateChange={handleStateChange}
      itemListClassName={"nav"}
      customBurgerIcon={false}
      width={'80%'}
      id={`js-menu-drawer`}
    >
      
      <div id="js-menu-right" className="nav__wrapper">
        <div className="nav__header">
          <div className="nav__close-btn" onClick={() => handleCloseMenu()}>
            <img src={"/images/icon_close.svg"} />
          </div>
          <div className="nav__header__wrap">
            <div className="nav__header__left">
              <div className="nav__header__avatar">
                <img
                  src={avatar_path}
                  alt="#"
                />
              </div>
            </div>
            <div className="nav__header__right">
              <h2 className={'text-truncate'}>{userInfo?.nickname || ''}</h2>
              <p>{userInfo?.email || ''}</p>
            </div>
          </div>
        </div>
        <div className="nav__body">
          <div className="nav__profile">
            <div>
              <a
                  // to={ROUTERS.PROFILE}
                  href={'#'}
                  onClick={() => goToPage(ROUTERS.PROFILE)}
              >
                <span>내정보</span>{" "}
                <img
                  src={"/images/arrow_rignt_s.svg"}
                />
              </a>
            </div>
            <div className="nav__profile__div" />
            <div>
              <Link to={ROUTERS.CHILDREN_SETTING} onClick={handleCloseMenu}>
                <span>맞춤정보</span>{" "}
                <img
                  src={"/images/arrow_rignt_s.svg"}
                />
              </Link>
            </div>
          </div>
          <div className="nav__section">
            <div className="nav__section__item">
              <Link to={ROUTERS.NOTIFICATION} onClick={handleCloseMenu}>
                <img src={"/images/icon_notice.svg"} />{" "}
                <span>공지사항</span>
              </Link>
            </div>
          </div>
          <div className="nav__section">
            <div className="nav__section__item">
              <a href="#">
                <img
                  src={
                    "/images/icon_communitycenter.svg"
                  }
                />{" "}
                <span>고객센터</span>
              </a>
              <ul>
                <li>
                  <Link to={ROUTERS.FAQ} onClick={handleCloseMenu}>자주하는 질문</Link>
                </li>
                <li>
                  <Link to={ROUTERS.QNA_CREATE} onClick={handleCloseMenu}>1:1 문의하기</Link>
                </li>
                <li>
                  <Link to={ROUTERS.QNA} onClick={handleCloseMenu}>나의 문의내역</Link>
                </li>
              </ul>
            </div>
          </div>
          <div className="nav__section">
            <div className="nav__section__item">
              <a href="#" onClick={() => goToPage(ROUTERS.NOTIFICATION_SETTING)}>
                <img className={'mt-1'} src={"/images/icon_bell.svg"} />{" "}
                <span>알림설정</span>
              </a>
            </div>
          </div>
          <div className="nav__section">
            <div className="nav__section__item">
              <a href="#">
                <img
                  src={"/images/icon_service.svg"}
                />{" "}
                <span>서비스정보</span>
              </a>
              <ul>
                <li>
                  <Link to={ROUTERS.INFORMATION_SERVICE_COMPANY} onClick={handleCloseMenu}>사업자정보</Link>
                </li>
                <li>
                  <Link to={ROUTERS.INFORMATION_SERVICE_TERM} onClick={handleCloseMenu}>이용약관</Link>
                </li>
                <li>
                  <Link to={ROUTERS.INFORMATION_SERVICE_POLICY} onClick={handleCloseMenu}>개인정보처리방침</Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="nav__foot">
          <a href={'#'} onClick={() => handleLogout()}>
            <img src={"/images/icon_logout.svg"} />{" "}
            <span>로그아웃</span>
          </a>
          <a href={'#'} onClick={deleteAccount}>
            <img src={"/images/icon_withdraw.svg"} />{" "}
            <span>탈퇴하기</span>
          </a>
        </div>

        <DialogComponent
            id={"MD3"}
            show={dialogDeleteUser}
            title={"알림"}
            closeBtn={"취소"}
            customBtn={'탈퇴하기'}
            handleCustom={onClickDeleteAccount}
            handleClose={()=>{
              setDialogDeleteUser(false)
            }}
            className={'dialog-custom-button'}
        >
          정말 회원탈퇴를 하시겠습니까?
        </DialogComponent>

        <DialogComponent
            id={""}
            show={dialogLogoutUser}
            title={"알림"}
            closeBtn={"취소"}
            customBtn={'로그아웃'}
            handleCustom={onClickLogout}
            handleClose={()=>{
              setDialogLogoutUser(false)
            }}
            className={'dialog-custom-button'}
        >
          정말 로그아웃 하시겠습니까?
        </DialogComponent>
      </div>

    </Menu>
  );
};

export default memo(Menubar);
